/** Protocol version */
export const TV_CONNECT_PROTOCOL_VERSION = 1;

/** Bonjour / NSD service type */
export const TV_CONNECT_MDNS_SERVICE_TYPE = "_hyview-tv-connect._tcp.";

/** Bonjour / NSD browse domain */
export const TV_CONNECT_MDNS_DISCOVERY_DOMAIN = "local.";
